import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1caed74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {} }
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 0,
  class: "my-form-control"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-upload",
  style: {"font-size":"18pt"}
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "btn btn-outline btn-file-input my-btn",
  type: "button"
}
const _hoisted_7 = {
  key: 2,
  class: "form-control",
  type: "text"
}
const _hoisted_8 = { class: "d-block w-100 text-nowrap overflow-hidden" }
const _hoisted_9 = ["name", "multiple", "accept", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["my-file-input", _ctx.inputGroupSize]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDialog && _ctx.openDialog(...args))),
      title: _ctx.filename
    }, [
      (_ctx.iconOnly == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      ((_ctx.iconOnly ?? false) == false)
        ? (_openBlock(), _createElementBlock("button", _hoisted_6, " Pilih "))
        : _createCommentVNode("", true),
      (((_ctx.iconOnly ?? false) == false || _ctx.showIconPlaceholder == true) || _ctx.value != undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.filename), 1)
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2),
    _createElementVNode("input", {
      ref: "file",
      type: "file",
      name: _ctx.nameRef,
      multiple: _ctx.multiple,
      accept: _ctx.accept,
      disabled: _ctx.disabled,
      class: "d-none",
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)))
    }, null, 40, _hoisted_9),
    _renderSlot(_ctx.$slots, "default", { errorMessage: _ctx.errorMessage }, undefined, true)
  ]))
}